import { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import useUserDetails from '@/hooks/useUserDetails';
import { fetchDhData } from '@/slices/dhDataSlice';

const useDataHub = () => {
  const { dataHubs, activeDataHubId } = useAppSelector(state => state.dataHub);
  const { isUserPremium, isUserExpired } = useUserDetails();
  const dispatch = useAppDispatch();

  const [activeTab, setActiveTab] = useState<number>(0);

  const dataHubSymbols = dataHubs.find(dataHub => dataHub.id === activeDataHubId)?.symbols ?? [];
  const isDataHubEmpty = !dataHubSymbols.length;

  useEffect(() => {
    if (isUserPremium && !isUserExpired) dispatch(fetchDhData({ symbols: dataHubSymbols }));
  }, [activeDataHubId, isUserPremium]);

  return {
    activeTab,
    setActiveTab,
    isDataHubEmpty
  };
};

export default useDataHub;
